<template>
  <div class="card">
    <div class="card-body" style="min-height: 22rem">
      <div class="clearfix">
        <div class="float-end">
          <div class="flex-nowrap input-group input-group-sm mb-3">
            <label class="input-group-text bg-light">Dates</label>
            <date-picker v-model="paymentsDueDateSelected" class="dashboard-datepicker" fixed-position="top-right" @change="paymentsDueDateSelectedFn"></date-picker>
          </div>
        </div>
        <h4 class="card-title mb-4">Payments Due</h4>
      </div>
      <hr class="mb-4" />
      <div>
        <data-table :columns="ordersForDeliveryColumns" :rows="paymentsDueForCollectionReport.objects" :has-pagination="false" :has-search="false"/>
      </div>
    </div>
  </div>
</template>

<script>
import {PAYMENTS_DUE_FOR_COLLECTION_ON_A_DAY} from "@/gql";
import moment from "moment";
import DataTable from "@/components/data-table";

export default {
  name: "OrdersPaymentDue",
  components: {DataTable},
  data(){
    return {
      paymentsDueDateSelected: new Date(),
      ordersForDeliveryColumns: [
        {
          field: 'salesCustomer',
          label: 'Customer'
        },
        {
          field: 'invoiceId',
          label: 'Order'
        },
        {
          field: 'createdAt',
          label: 'Order Date'
        },
        {
          field: 'deliveryDate',
          label: 'Delivery Date'
        },
        {
          field: 'grossOrderTotal',
          label: 'Total'
        },
        {
          field: 'orderStatus',
          label: 'Order Status'
        }
      ],
      paymentsDueForCollectionReport: {
        objects: []
      },
      currentPage: 1,
      perPage: 30,
      paymentDates: [],
    }
  },
  apollo: {
    paymentsDueForCollectionReport: {
      query: PAYMENTS_DUE_FOR_COLLECTION_ON_A_DAY,
      variables(){
        return {
          page: this.currentPage,
          perPage: this.perPage,
          paymentDates: this.paymentDates
        }
      }
    },
  },
  methods: {
    paymentsDueDateSelectedFn(){
      this.paymentDates = [moment(this.paymentsDueDateSelected).format('YYYY-MM-DD')]
    },
  }
}
</script>

<style scoped>

</style>
